import {
  AppBar,
  Toolbar,
  Box,
  Container,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/header.css";
import logo from "../../assets/images/main_logo.png";
import BASE_URL from "../config/appconfig";

const AdminHeader = () => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [userName, setUserName] = useState("Admin");

  const open = Boolean(anchorEl);

  useEffect(() => {
    try {
      const personId = JSON.parse(localStorage.getItem("userData"))?._id;
      if (!personId) return;
      fetch(`${BASE_URL}/api/people/people-id/${personId}`)
        .then((r) => r.json())
        .then((json) => {
          if (json.success && json.data?.full_name) {
            setUserName(json.data.full_name);
          }
        })
        .catch(() => {});
    } catch {}
  }, []);

  // Generate initials
  const getInitials = (name) => {
    const parts = name.split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase();
  };

  const initials = getInitials(userName);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${BASE_URL}/api/admin/logout`, { method: "POST" });
    } catch {}
    localStorage.removeItem("userData");
    localStorage.removeItem("userName");
    localStorage.removeItem("pendingUser");
    navigate("/sign-in");
  };

  return (
    <AppBar position="static" elevation={0} className="admin-header">
      <Container maxWidth={false} disableGutters>
        <Toolbar
          className="admin-toolbar"
          sx={{ width: "80%", mx: "auto", px: "0 !important" }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={logo}
            alt="App Logo"
            className="admin-logo"
          />

          {/* Admin Profile */}
          <Box
            className="admin-profile"
            onClick={handleMenuOpen}
            sx={{ cursor: "pointer" }}
          >
            {/* Avatar */}
            <Box
              className="admin-avatar"
              sx={{
                color: "#333",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                fontSize: "18px",
                textTransform: "uppercase",
              }}
            >
              {initials}
            </Box>

            {/* Name */}
            <Typography className="admin-text">{userName}</Typography>
          </Box>

          {/* Dropdown Menu */}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                handleLogout();
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default AdminHeader;
